// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/transportation/flight_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_transportation_flight } from "./flight_pb";

/**
 * Describes the file proto/model/feature/transportation/flight_preferences.proto.
 */
export const file_proto_model_feature_transportation_flight_preferences = /*@__PURE__*/
  fileDesc("Cjtwcm90by9tb2RlbC9mZWF0dXJlL3RyYW5zcG9ydGF0aW9uL2ZsaWdodF9wcmVmZXJlbmNlcy5wcm90bxIGY2FybWVuIsMBChFGbGlnaHRQcmVmZXJlbmNlcxInCgtjYWJpbl9jbGFzcxgBIAEoDjISLmNhcm1lbi5DYWJpbkNsYXNzEhoKEm1heF9kdXJhdGlvbl9ob3VycxgCIAEoBRIRCgltYXhfc3RvcHMYAyABKAUSKwoScHJlZmVycmVkX2FpcmxpbmVzGAQgAygLMg8uY2FybWVuLkFpcmxpbmUSKQoQYXZvaWRlZF9haXJsaW5lcxgFIAMoCzIPLmNhcm1lbi5BaXJsaW5lQj9aPWdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvdHJhbnNwb3J0YXRpb25iBnByb3RvMw", [file_proto_model_feature_transportation_flight]);

/**
 * Describes the message carmen.FlightPreferences.
 * Use `create(FlightPreferencesSchema)` to create a new message.
 */
export const FlightPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_transportation_flight_preferences, 0);

